import React from "react";

import Stack, { StackProps } from "@mui/material/Stack";
import styled from "@mui/material/styles/styled";

import { SUBNAV_OFFSET_PX } from "@app/analytics/MeetingReport/constants";

import { ContentSection, SectionContainer } from "./styles";

export interface ReportSubsectionProps extends StackProps {
  id: string;
  children: React.ReactNode;
  overlay?: React.ReactNode;
  disablePaddingTop?: boolean;
}

const ScrollContainer = styled(Stack)(({ theme }) => ({
  scrollMarginTop: SUBNAV_OFFSET_PX,
  paddingBottom: theme.spaces.base,
  position: "relative",
  "&:not(.no-padding):first-of-type": {
    paddingTop: "72px",
    [theme.breakpoints.up("mobile")]: {
      paddingTop: "80px",
    },
  },
  "&:last-of-type": {
    paddingBottom: theme.spaces.xlarge,
  },
}));

const ReportSubsection = ({
  children,
  disablePaddingTop = false,
  id,
  overlay = null,
  ...props
}: ReportSubsectionProps) => (
  <ScrollContainer
    data-scroll-id={id}
    className={`report-subsection__scroll-container${
      disablePaddingTop ? " no-padding" : ""
    }`}
  >
    <SectionContainer>
      <ContentSection {...props}>{children}</ContentSection>
    </SectionContainer>
    {overlay}
  </ScrollContainer>
);

export default ReportSubsection;
